exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.setting_options_category_item_icon[data-v-16211962],\n.setting_form_text[data-v-16211962] {\n  cursor: pointer;\n}\n.setting_options_category_item[data-v-16211962] {\n  padding: 0px 7px !important;\n  width: 100% !important;\n}\n.setting_form_wrapper_delete[data-v-16211962] {\n  margin: 8px 0 0 8px !important;\n}\n.customize_setting_text[data-v-16211962] {\n  border: unset !important;\n}\n.setting_form_wrapper_close[data-v-16211962] {\n  top: 55%;\n}\n", ""]);

// exports
